import { render, staticRenderFns } from "./publications.vue?vue&type=template&id=41f66992&scoped=true"
import script from "./publications.vue?vue&type=script&lang=js"
export * from "./publications.vue?vue&type=script&lang=js"
import style0 from "./publications.vue?vue&type=style&index=0&id=41f66992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f66992",
  null
  
)

export default component.exports